import {MutationTree} from "vuex";
import {WebConferenceState} from "@share/web-conferences/store/WebConferenceState";

export const mutations: MutationTree<WebConferenceState> = {
    setJoinedUserIds(state, data) {
        state.joinedUserIds = data;
    },
    setPresenters(state, data) {
        state.presenters = data;
    },
    setAgora(state, data) {
        state.agora = data;
    },
    setRaisedHandUsers (state, data) {
        state.raisedHandUsers = data;
    },
    setRemovedSpeakers(state, data) {
        state.removedSpeakers = data;
    },
    setRecordingStarted(state, value) {
        state.recordingStarted = value;
    },
    setWebConferenceData(state, value) {
        state.webConferenceData = value;
    },
    setTracksManager(state, value) {
        state.tracksManager = value;
    }
}
